const CouplerTypes = Object.freeze({
  PinGrab: 'Pin Grab',
  Wedge: 'Wedge',
  Symmetrical: 'Symmetrical',
  BobcatBxc: 'Bobcat BXC',
  WainRoy: 'Wain Roy',
  FullyAutomatic: 'Fully Automatic',
  Other: 'Other',
});

export { CouplerTypes };
